export enum Routes {
  HOME = '/',
  NEWS = '/news',
  UEBER_UNS = '/ueber_uns',
  ANMELDUNGEN = '/anmeldungen',
  TEAM = '/team',
  UNSERE_LOKALE = '/unsere_lokale',
  STUNDENPLAN_OBERWINTERTHUR = '/stundenplan_oberwinterthur',
  STUNDENPLAN_WINTERTHUR = '/stundenplan_winterthur',
  STUNDENPLAN_WIESENDANGEN = '/stundenplan_wiesendangen',
  GALERIE = '/galerie',
  KONTAKT = '/kontakt',
  ERWACHSENE = '/erwachsene',
  KINDER = '/kinder',
  PREISE = '/preise',
  CIE_AHA_PLUS = '/cie_aha_plus',
  FOERDERKLASSE = '/foerderklasse',
  SCHNUPPERLEKTION = '/schnupperlektion',
  FAQ = '/faq',
}
